/** Intake dropdown options — aligned with nurse station intake modes where applicable. */

export const MODE_OF_ARRIVAL_OPTIONS = [
  { value: '', label: 'Select mode of arrival' },
  { value: 'Walk-in', label: 'Walk-in' },
  { value: 'Ambulance', label: 'Ambulance' },
  { value: 'Private', label: 'Private vehicle' },
  { value: 'Carried', label: 'Carried / assisted' },
  { value: 'Wheelchair', label: 'Wheelchair' },
  { value: 'Public transport', label: 'Public transport' },
  { value: 'Other', label: 'Other' },
];

export const ACCOMPANIED_BY_OPTIONS = [
  { value: '', label: 'Select accompaniment' },
  { value: 'Self', label: 'Self (unaccompanied)' },
  { value: 'Spouse', label: 'Spouse / partner' },
  { value: 'Parent', label: 'Parent' },
  { value: 'Guardian', label: 'Guardian' },
  { value: 'Relative', label: 'Other relative' },
  { value: 'Friend', label: 'Friend' },
  { value: 'Health worker', label: 'Health worker' },
  { value: 'Police', label: 'Police / security' },
  { value: 'Other', label: 'Other' },
];
